/**
 * Module Vuex pour la gestion des filtres de dates des tableaux/listes.
 * Permet de persister les sélections de période entre les navigations.
 */
const state = {
	dateFilters: {}
}

const mutations = {
	setTableDate(state, params) {
		const tableId = params.tableId

		state.dateFilters[tableId] = {
			begin: params.beginDate,
			end: params.endDate,
			period: params.period,
			time: params.time
		}
	},

	deleteTableDate(state, tableId) {
		delete state.dateFilters[tableId]
	}
}

const getters = {
	getTableDate: (state) => (tableId) => {
		return state.dateFilters[tableId]
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	getters
}
